<template>
  <TrackingScreen
    ref="trackingScreen"
    :ble-id="bleId"
    :asset-id="assetId"
    :t="t"
  />
</template>
<script>
import TrackingScreen from '../../components/organisms/nb-iot/tracking-screen';

export default {
  name: 'NbIotDetail',
  components: {
    TrackingScreen,
  },
  props: {
    assetId: { type: String, default: null },
    t: { type: String, default: '' },
    bleId: { type: String, default: null },
  },
};
</script>
